<template>
  <div id="app">
    <img
      v-if="showBtn"
      @click="clickNumberMen"
      src="./assets/layout/number_btn.gif"
      :draggable="false"
      class="number-btn"
    />
    <img
      v-if="showBtn"
      @click="clickNumberMen"
      src="./assets/layout/number_btn.png"
      :draggable="false"
      class="number-txt"
    />
    <div v-if="showHuman" id="human-container">
      <iframe
        src="https://next-pre.zs-meta.com/#/h5/szjc"
        allow="microphone; camera"
      />
      <div class="close-btn" @click="() => this.showHuman = false"><img src="./assets/virtual/close.png" alt=""></div>
    </div>
    <router-view />
  </div>
</template>

<script>
// import utils from './utils/utils'
// import qs from "qs";
export default {
  name: 'App',
  data () {
    return {
      meta: null,
      renderStatus: false,
      metaDom: null,
      showBtn: false,
      showNumberMen: false,
      own_token: '',
      showHuman: false
    }
  },
  // async created() {
  //   await this.ownLoad('a85ce22f8c406dbcb55c4764fca7207fd310f460')
  //   this.textToAnim('大家好')
  //   setTimeout(() => {
  //     if (this.$route.name && this.$route.name !== 'login') {
  //       this.showBtn = true
  //     }
  //     window._METAMAKER_SERVICE.load('a85ce22f8c406dbcb55c4764fca7207fd310f460')
  //     this.meta = window._METAMAKER_SERVICE
  //     this.$nextTick(() => {
  //       const meta = document.querySelector('#_metakmaker_service_wrapper')
  //       this.metaDom = meta
  //       meta.style.zIndex = 999
  //       meta.style.top = '-1080px'
  //     })
  //     // window._METAMAKER_SERVICE.loadedPromise.then(() => {
  //     //   utils.hideLoading()
  //     // })
  //   }, 300)
  // },
  watch: {
    '$route.name': {
      handler: function (newValue) {
        if (newValue && newValue !== 'login') {
          // this.metaDom && this.showMeta()
          this.showBtn = true
        } else {
          this.showBtn = false
          // this.metaDom && (this.metaDom.style.top = '-1080px')
        }
      },
      immediate: true,
      deep: true
    }
  },
  // mounted() {
  //   this.metaDom.style.top = "-1080px";
  //   window.onresize = () => {
  //     setTimeout(() => {
  //       this.showMeta();
  //     }, 100);
  //   };
  // },
  methods: {
    clickNumberMen () {
      // this.showNumberMen = !this.showNumberMen
      // if (this.showNumberMen) {
      //   if (!this.renderStatus) {
      //     this.meta.show()
      //     this.renderStatus = true
      //   }
      //   this.metaDom.style.top = '116.125px'
      //   utils.showLoading(180, 375)
      //   // const showRes = window._METAMAKER_SERVICE.show()
      //   // await showRes.loadedPromise()
      //   // utils.hideLoading()
      //   // console.log(showRes, '========================>showRes')
      // } else {
      //   this.metaDom.style.top = '-1080px'
      //   utils.hideLoading()
      //   // window._METAMAKER_SERVICE.hidden()
      // }
      this.showHuman = !this.showHuman
    }
    // showMeta() {
    //   this.metaDom.style.top = this.showNumberMen ? 0 : "-1080px";
    // },
    // async ownLoad (t) {
    //   const r = new FormData()
    //   let n
    //   r.append('app_key', t)
    //   try {
    //     n = await fetch(
    //       'https:///open.metamaker.cn/api/human_console/v1//project/gen_auth',
    //       { method: 'post', body: r, mode: 'cors' }
    //     )
    //   } catch (i) {
    //     // return void (this.sandbox.innerText = '鐢熸垚TOKEN澶辫触')
    //     return console.log(`token 获取失败 ${i}`)
    //   }
    //   n = await n.json()
    //   const o = n.ret
    //   console.log(`own_token: ${o}`)
    //   this.own_token = o
    //   // localStorage.setItem('METAMAKER_TOKEN', o)
    // },
    // async textToAnim(text) {
    //   const tts = {
    //     voice_name: "zh-CN-XiaoxiaoNeural",
    //     speed: 33.6,
    //     volume: 50
    //   };
    //   let response = await fetch(
    //     "//open.metamaker.cn/api/human_developer/v1/text_to_anim",
    //     {
    //       method: "post",
    //       headers: {
    //         "Content-Type": "application/x-www-form-urlencoded",
    //         Authorization: this.own_token
    //       },
    //       body: qs.stringify({
    //         text,
    //         tts_args: JSON.stringify(tts),
    //         audio_type: "wav",
    //         storage_type: "cloud"
    //       }),
    //       mode: "cors"
    //     }
    //   );

    //   response = await response.json();
    //   if (response.err_code !== 0) {
    //     throw new Error("fetch tts failed");
    //   }
    //   console.log(response, "===============================>response");
    // }
  }
}
</script>

<style lang="less">
@import url(./styles/default.less);
.el-divider {
  margin: 0px !important;
  padding: 0px !important;
}
#app {
  position: relative;
}
.number-btn {
  width: 68px;
  position: fixed;
  right: 25px;
  bottom: 126px;
  z-index: 9999999;
  cursor: pointer;
}
.number-txt {
  width: 62px;
  position: fixed;
  right: 28px;
  bottom: 104px;
  z-index: 9999999;
  cursor: pointer;
}
#hj-metamaker-close-btn {
  display: none !important;
}
#_metakmaker_service_wrapper {
  left: 0 !important;
  // transform: translateY(-50%);
}

#human-container {
  position: fixed;
  z-index: 99;
  top: 15vh;
  left: 30px;
  width: 40vh;
  height: 70vh;
  border-radius: 12px;
  overflow: hidden;

  .close-btn {
    position: absolute;
    right: 8px;
    top: 8px;
    cursor: pointer;
    width: 30px;
    height: 30px;
    img {
      width: 100%;
    }
  }
}

#human-container iframe {
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  border-image: linear-gradient(
      325deg,
      rgba(255, 255, 255, 0.4),
      rgba(255, 255, 255, 0)
    )
    8 8;
  backdrop-filter: blur(2px);
  width: 100%; /* iframe宽度100%，即父元素宽度 */
  height: 100%; /* iframe高度100%，即父元素高度 */
  border: none; /* 移除边框，可选 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue